import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ReservationSummaryStoreService } from '../services/reservation-summary-store.service';
import { Alert, Reservation } from '../../reservation.model';
import { DataBagService } from '../../../common/data-bag.service';
import { ReservationSummaryApiService } from '../services/reservation-summary-api.service';
import { LoaderService } from '../../../common/loader/loader.service';
import { InfoboxService } from '../../../common/infobox/infobox.service';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-reservation-summary-alerts',
	templateUrl: './reservation-summary-alerts.component.html',
	styleUrls: ['./reservation-summary-alerts.component.scss'],
	providers: [DatePipe],
})
export class ReservationSummaryAlertsComponent implements OnInit, OnDestroy {
	private _subscription: Subscription = null;
	private reservation: Reservation = null;
	alerts: Alert[] = [];
	showAllAlerts = false;

	constructor(
		public store: ReservationSummaryStoreService,
		private readonly api: DataBagService,
		private readonly loader: LoaderService,
		private readonly apiService: ReservationSummaryApiService,
		private readonly infobox: InfoboxService,
		private readonly datePipe: DatePipe,
	) {}

	ngOnInit() {
		const { reservation } = this.store.getters();

		this._subscription = reservation()?.subscribe((val) => {
			this.reservation = val;
			this.alerts = val?.alerts;
			this.filterAlerts();
		});
	}

	ngOnDestroy() {
		this._subscription?.unsubscribe();
	}

	filterAlerts() {
		this.alerts = this.showAllAlerts ? this.reservation?.alerts : this.reservation?.alerts.filter((v) => v.active);
	}

	get isAnyNonActiveAlert() {
		return this.reservation?.alerts.some((v) => !v.active);
	}

	toggleActive(alert: Alert) {
		this.loader.show('alerts-loader');
		this.api.put(`/reservation/reservation_alert/${alert.id}/`, { active: !alert.active }, (result, error) => {
			setTimeout(() => {
				this.showAllAlerts = false;
				this.loader.hide('alerts-loader');
				this.apiService.actions().getReservation(this.reservation.id);
				if (result) this.infobox.success('Pomyślnie zmieniono widocznośc alertu');
				else this.infobox.error(`Zmienienie widoczności alertu nie powiodło się, błąd: ${error}`);
			}, 300); // setting a timeout because backend sometimes doesn't keep up
		});
	}

	protected getModifiedByTooltipMessage(alert: Alert): string {
		const modifiedDate = this.datePipe.transform(alert.lastModified, 'dd-MM-yyyy');
		return `Ostatnia zmiana: ${modifiedDate}. Zmodyfikowano przez: ${alert.modifiedBy.firstName} ${alert.modifiedBy.lastName}`;
	}
}
